import React from 'react';

import { BulkCreateContainer } from './BulkCreateContextProvider.tsx';
import { AiBulkNavigationContextContainer } from './AiBulkNavigationContextProvider.tsx';
import { BulkConfigureContextContainer } from './BulkConfigureContextProvider.tsx';

type BulkIssueCreateProvidersWrapperProps = {
	children?: React.ReactNode;
};
export const BulkIssueCreateProvidersWrapper: React.FC<BulkIssueCreateProvidersWrapperProps> = ({
	children,
}) => {
	return (
		<BulkCreateContainer isGlobal>
			<AiBulkNavigationContextContainer>
				<BulkConfigureContextContainer>{children}</BulkConfigureContextContainer>
			</AiBulkNavigationContextContainer>
		</BulkCreateContainer>
	);
};
